"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToLocalISO = void 0;
const dateToLocalISO = function (timeStamp, timeZone) {
    // off为当地时区相对UTC的偏移量，日本为9，中国为8
    const off = -timeZone * 60;
    const absoff = Math.abs(off);
    return `${new Date(timeStamp * 1000 - off * 60 * 1000).toISOString().substr(0, 23) +
        (off > 0 ? '-' : '+') +
        (absoff / 60).toFixed(0).padStart(2, '0')}:${(absoff % 60).toString().padStart(2, '0')}`;
};
exports.dateToLocalISO = dateToLocalISO;
